import { VFC, ReactNode } from "react";
import classNames from "classnames";
import Styles from "./Modal.module.scss";

/**
 * The modal body component properties.
 */
export interface ModalBodyProps {
  /**
   * The CSS class name.
   */
  readonly className?: string;

  /**
   * The children.
   */
  readonly children: [content: ReactNode, footer: ReactNode];
}

/**
 * The body of a modal.
 */
export const ModalBody: VFC<ModalBodyProps> = (props: ModalBodyProps): JSX.Element | null => {
  const { className, children } = props;
  const [content, footer] = children;

  return (
    <div className={classNames(Styles.modalBody, className)}>
      <div className="content">{content}</div>
      <div className="footer">{footer}</div>
    </div>
  );
};
